// Sugar Alarm — cycle 475: the Shield Glow surface behind the onboarding
// "Connect your CGM" step. LoginScreen renders it ONLY for the first
// provider step; sign-in, connect and connected keep the pre-475 column.
//
// Order: artwork (decorative) → bottom shade → the official lockup with a
// soft blue halo → gold eyebrow → heading → intro → the choices (children:
// `<ProviderPicker presentation="onboarding">`) → the privacy line, in flow.
//
// `layout` is chosen by the caller from the runtime frame variant
// (`useFrameVariant`): the kiosk and web variants draw the tablet layout,
// the mobile variant the phone layout. `fitFrame` (inside the kiosk frame)
// fills the column the frame gives it, exactly as the pre-475 column did.

import type { ReactNode } from "react";

import { LockIcon } from "../../components/ui/icons";
import s from "./ShieldGlow.module.css";

export type ShieldGlowLayout = "tablet" | "phone";

interface Props {
  layout: ShieldGlowLayout;
  fitFrame: boolean;
  children: ReactNode;
}

export function ShieldGlowSurface({ layout, fitFrame, children }: Props) {
  const rootClass = [s.root, layout === "phone" ? s.phone : s.tablet, fitFrame ? s.fit : s.page].join(
    " ",
  );
  return (
    <div className={rootClass} data-surface="shield-glow" data-layout={layout}>
      <div className={s.art} aria-hidden="true" />
      <div className={s.shade} aria-hidden="true" />
      <div className={s.content}>
        <span className={s.brand}>
          {/* The official lockup (cycle-396 artwork) with its transparent
              outer padding trimmed so it fills the ~52 px slot; the aspect
              ratio is the image's own (width: auto). */}
          <img
            className={s.brandImg}
            src="/onboarding/shield-glow/sugar-alarm-lockup-tight.png"
            alt="Sugar Alarm"
            width={935}
            height={250}
          />
        </span>
        <p className={s.eyebrow}>YOUR PEACE OF MIND STARTS HERE</p>
        <h1 className={s.title}>Connect your CGM</h1>
        {/* A no-break space keeps the brand name on one line on a phone. */}
        <p className={s.intro}>Choose your glucose monitor or pair with your Sugar{" "}Alarm app.</p>
        {children}
        <p className={s.footer}>
          <LockIcon size={13} className={s.footerIcon} />
          <span>Your data is encrypted at rest. Sugar Alarm never sells health data.</span>
        </p>
      </div>
    </div>
  );
}
